import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import BackHomeButton from '../components/BackHomeButton';
import { deleteDoc, doc } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';
import AutoScrollPreview from "../components/AutoScrollPreview";
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';



function UserUploadsPage() {
  const [uploads, setUploads] = useState([]);
  const [filteredUploads, setFilteredUploads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [documentTypeFilter, setDocumentTypeFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const uploadsPerPage = 5;
  const navigate = useNavigate();

const handleDelete = async (uploadId, storagePath) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this file?");
  if (!confirmDelete) return;

  try {
    //const db = getFirestore();
    const storage = getStorage();

    // Delete from Firestore
    const uploadRef = doc(db, 'uploads', uploadId);
    await deleteDoc(uploadRef);

    // Delete from Firebase Storage
    if (storagePath) {
      const fileRef = ref(storage, storagePath);
      await deleteObject(fileRef);
    }

    // Update local state
    setUploads(prev => prev.filter(upload => upload.id !== uploadId));
  } catch (error) {
    console.error("Error deleting file:", error);
    alert("Failed to delete file.");
  }
};



  useEffect(() => {
    const fetchUploads = async () => {
      //const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        //const db = getFirestore();
        const uploadsRef = collection(db, "uploads");
        const uploadsQuery = query(uploadsRef, where("uid", "==", user.uid));
        const querySnapshot = await getDocs(uploadsQuery);

        const userUploads = querySnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => (b.uploadTime?.seconds || 0) - (a.uploadTime?.seconds || 0));

        setUploads(userUploads);
        setFilteredUploads(userUploads);
      }

      setLoading(false);
    };

    fetchUploads();
  }, []);

  useEffect(() => {
    let filtered = uploads;

    if (documentTypeFilter !== 'All') {
      filtered = filtered.filter(
        u => u.type?.includes(documentTypeFilter)
      );
    }

    if (searchTerm.trim()) {
      filtered = filtered.filter(u =>
        (u.fileName || '').toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

      // ✅ Sort descending by date
      filtered.sort((a, b) => (b.uploadTime?.seconds || 0) - (a.uploadTime?.seconds || 0));

    setFilteredUploads(filtered);
    setCurrentPage(1); // Reset to first page when filter/search changes
  }, [documentTypeFilter, searchTerm, uploads]);

  const indexOfLast = currentPage * uploadsPerPage;
  const indexOfFirst = indexOfLast - uploadsPerPage;
  const currentUploads = filteredUploads.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredUploads.length / uploadsPerPage);

  if (loading) return <div>Loading...</div>;

 return (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

    <BackHomeButton className="mt-6" />

    <h2 className="text-3xl font-bold mb-8 text-gray-800">
      Your Uploaded Files.
    </h2>
    <p>Total Files : {uploads.length} Shown Newest first to Oldest</p>
    <br></br>

    {/* Filter + Search */}
    <div className="flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between mb-8">
      <div className="flex items-center gap-3">
        <label className="font-semibold text-gray-700">
          Filter by Type:
        </label>
        <select
          value={documentTypeFilter}
          onChange={(e) => setDocumentTypeFilter(e.target.value)}
          className="px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="All">All</option>
          <option value="Worksheet">Worksheet</option>
          <option value="Quiz">Quiz</option>
          <option value="Assessment">School Assessment</option>
        </select>
      </div>

      <input
        type="text"
        placeholder="Search by File Name,Subject,Lesson ,Topic etc. etc."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full sm:w-172 px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

    <div>
      <p className="text-gray-500">{filteredUploads.length} Files found.</p>
    </div>

    <br></br>

    {/* Uploads Grid */}
    {filteredUploads.length === 0 ? (
      <p className="text-gray-500">No uploads found.</p>
    ) : (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {filteredUploads.map((upload) => {
          const date = upload.uploadTime?.seconds
            ? new Date(upload.uploadTime.seconds * 1000).toLocaleDateString()
            : 'Unknown date';

          return (
            <div
              key={upload.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden border"
            >
              {/* File Preview */}
              
              <div className="bg-gray-100 flex items-center justify-center h-[400px] lg:h-[450px]">
                {upload.fileUrl?.toLowerCase().includes('.pdf') ? (
                  /Android/i.test(navigator.userAgent) ? (
                    <iframe
                      src={`https://docs.google.com/gview?url=${encodeURIComponent(upload.fileUrl)}&embedded=true`}
                      title="preview"
                      loading="lazy"
                      className="w-full h-full"
                    />
                  ) : (
                    <iframe
                      src={`${upload.fileUrl}#toolbar=0&navpanes=0&scrollbar=1`}
                      title="preview"
                      loading="lazy"
                      className="w-full h-full"
                    />
                  )
                ) : (
                  <img
                    src={upload.fileUrl}
                    alt="preview"
                    loading="lazy"
                    className="object-cover w-full h-full"
                  />
                )}
              </div>
              

              {/* File Details */}
              <div className="p-4">

                <h3
                  className="pt-2 font-semibold text-gray-800 text-sm truncate"
                  title={upload.fileName} // ✅ shows full name on hover
                >
                  {upload.fileName}
                </h3>

                <p className="text-xs text-gray-500 mt-1">
                  Upload Time: {date}
                </p>

                {upload.subject && (
                  <p className="text-xs text-gray-500 mt-1">
                    School: {upload.school}
                  </p>
                )}

                {upload.subject && (
                  <p className="text-xs text-gray-500 mt-1">
                    Standard: {upload.standard}
                  </p>
                )}

                {upload.subject && (
                  <p className="text-xs text-gray-500 mt-1">
                    Subject: {upload.subject}
                  </p>
                )}

                {upload.type && (
                  <p className="text-xs text-blue-600 font-medium mt-1">
                    File Type: {upload.type}
                  </p>
                )}

                <p className="text-xs text-gray-600 mt-2 line-clamp-2">
                  Description: {upload.description}
                </p>

                <div className="flex gap-2 mt-4">
                  <a
                    href={upload.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 text-center text-xs bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg transition"
                  >
                    Download
                  </a>

                  <button
                    onClick={() =>
                      navigate("/Email_Worksheet", { state: { fileUrl: upload.fileUrl } })
                    }
                    className="flex-1 text-xs bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg transition font-medium shadow-sm"
                  >
                    Share
                  </button>

                  <button
                    onClick={() => handleDelete(upload.id, upload.storagePath)}
                    className="flex-1 text-xs bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg transition"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}

    <footer className="mt-16 py-6 bg-gray-900 text-white text-center rounded-xl">
      <p className="text-sm">© 2026 Eascode All Rights Reserved.</p>
    </footer>
  </div>
);
}


export default UserUploadsPage;
